import { useQuery } from '@apollo/client';
import React from 'react';
import { Spinner } from 'react-bootstrap';
import { GET_PROFESSIONS } from '../../../graphql/member';
import MultiSelectList from '../MultiSelectList';
import { CoreProfessionSelectProps } from './CoreProfessionSelectProps';
import { useCoreProfessions } from './useCoreProfessions';

const CoreProfessionSelect: React.FC<CoreProfessionSelectProps> = (
    props: CoreProfessionSelectProps
) => {
    const { name, value, onChange, showValidation } = props;
    const { data, error, loading } = useQuery(GET_PROFESSIONS);
    const { models, operations } = useCoreProfessions({ data });
    const { professions } = models;
    const currentValue = value ?? [];
    const selectableProfessions = professions ?? [];
    const knownProfessions = [
        ...selectableProfessions,
        ...currentValue.filter(
            (selected) =>
                !selectableProfessions.some(
                    (profession) => profession.professionId === selected.professionId
                )
        ),
    ];

    return professions ? (
        <MultiSelectList
            required
            showValidation={showValidation}
            name={name}
            availableOptions={
                professions?.map((profession) => {
                    return {
                        id: profession.professionId,
                        label: profession.name,
                    };
                }) as any
            }
            value={
                currentValue.map((value) => {
                    return { id: value.professionId, label: value.name };
                }) as any
            }
            onChange={(value) =>
                onChange(
                    knownProfessions.filter((x) =>
                        value.map((x) => x.id).includes(x.professionId)
                    )
                )
            }
        />
    ) : (
        <Spinner size="sm" />
    );
};

export default CoreProfessionSelect;
